export interface NativeNavigationOptions {
  showExitConfirmationOverlay?: boolean;
  showBackArrow?: boolean;
  showProfileSettings?: boolean;
  showClose?: boolean;
  showCancel?: boolean;
  pageTitle?: string;
}

export enum NavigationPanelActions {
  BACK = 'BACK',
  CLOSE = 'CLOSE',
}
